module.exports = __webpack_public_path__ + "img/s2.4a56e651.svg";